// tslint:disable
export const en = {
  VerifyStatus: 'UID Verification',
  MarkAsDispensed: 'Mark as Dispensed',
  MarkAsSampled: 'Mark as Sample',
  UndoDispense: 'Undo Supply',
  UndoSample: 'Undo Sample',
  MarkAsDestroyed: 'Mark as Destroyed',

  Alert: 'Alert',
  ErrorCode: 'Error Code',
  WarningFromNmvs: 'Warning from the National Medicine Verification System, for EPC',
  Reason: 'Reason',
  ContactAcknowledge: 'Please contact a member of your group to acknowledge this message.',
  Acknowledge: 'Acknowledge',

  CleanDateFormat: 'mmm dS, yyyy  h:MM:ss TT',
  ExpiryDateFormat: 'mmmm dd, yyyy',
  ShortenedExpiryDateFormat: 'mmm dd, yyyy',

  ClearCompleted: 'Clear Completed',
  ManualEntry: 'Manual Entry',

  FileName: 'File Name',
  Download: 'Download',
  ImvoPilotSetupInstructions: 'IMVO Pilot Setup Instructions',
  ZebraDevicesSetupInstructions: 'Zebra Devices Setup Instructions',
  DataLogicGryphonGD4400: 'DataLogic Gryphon GD4400',
  DataLogicMagellan9800i: 'DataLogic Magellan 9800i',
  DataLogicMagellan3200VSI: 'DataLogic Magellan 3200 VSI',
  '232KeyConfiguration': '232Key configuration settings for DataLogic Magellan 3200 VSI',

  ProductDetails: 'Product Details',
  UserDetails: 'User details',
  ProductIdentification: 'Properties',
  SerialNumber: 'Unique Identifier',
  Expiry: 'Expiry Date',
  LotNumber: 'Lot Number',
  Status: 'Status',

  DeviceInfo: 'Device Info',
  UserProfile: 'Profile',
  Users: 'Users',
  Settings: 'Settings',
  Documentation: 'Documentation',
  Logout: 'Logout',

  LoginErrorConnectivity: 'You must have internet connectivity to log in for the first time.',
  SessionTimeout: 'Session timeout.',
  InvalidUsernamePassword: 'Username/Password is invalid.',
  Unauthorized: 'Unauthorized.',
  TenantDoesNotExist: 'Client does not exist for ID: ',
  Username: 'Username',
  Password: 'Password',
  UsernameRequirement: 'Username must be between 5 and 50 characters',
  RetypePassword: 'Confirm password',
  Login: 'Log in',
  FirstName: 'First Name',
  LastName: 'Last Name',
  ForgotPassword: 'Forgot password',
  ConfirmPasswordReset: 'Confirm Password Reset',
  ConfirmPasswordResetMessage: 'Are you sure you want to request a password reset for {{username}} ?',
  ResetPassword: 'Reset Password',
  PasswordResetSuccess: 'An email has been sent to the email address. Please follow the instructions in it to complete the password reset.',
  PasswordResetError: 'Error: could not send the password reset email. Please try again in a few minutes.',
  PasswordResetOfflineError: 'Error: You must be online to reset your password.',
  ForgotPasswordContactAdmin: 'Please contact your Active Directory administrator.',
  Email: 'Email',
  OtherActions: 'Other Actions',
  UserInfoWarning: 'Warning: Username, First Name, and Last Name cannot be changed after user creation.',

  ScannedDateTime: 'Scan Date/Time',
  NmvsResponseTime: 'NMVS Response Time',
  OptelResponseTime: 'Optel Response Time',
  TotalResponseTime: 'Total Response Time',
  Seconds: 'seconds',
  NotApplicable: 'N/A',

  Scan: 'Scan',
  ScanOrTypeEpc: 'Scan or type the Electronic Product Code',
  EnterEpcManually: 'Enter Epc Manually',
  EpcScannedAuditMessage: '{{username}} scanned the Epc: {{epc}}, with Operation: {{operation}}',
  AlertAcknowledgedAuditMessage: 'Alert acknowledged by {{username}} for clientTransactionId: {{clientTransactionId}}',
  Pending: 'Pending',
  NotFound: 'Not Found',
  ProductCodeRequired: 'A product code is required.',
  SerialNumberRequired: 'A serial number is required.',
  BatchIdentifierRequired: 'A batch identifier is required.',
  ExpiryDateRequired: 'An expiry date is required.',
  UnprocessableEntity: 'Unprocessable Entity',

  DeviceId: 'Device Identifier',
  SystemInfo: 'System Info',
  Preferences: 'Preferences',
  Credentials: 'Credentials',
  Country: 'Country',
  Language: 'Language',
  LocationIdentifier: 'Location Identifier',
  Certificate: 'Certificate',
  CertificatePassword: 'Certificate Password',
  Processing: 'Processing...',
  Save: 'Save',
  CreateUser: 'Create User',
  Submit: 'Submit',
  ClientId: 'Enter Client ID',
  FileNullError: 'An error occurred when reading the file.',
  InvalidFileError: 'Error: File needs to end with .pfx or .p12',
  OfflineSettingsMessage: 'You cannot update settings while in offline mode.',

  RegisterDevice: 'Register Device',
  UnregisterDevice: 'Unregister Device',
  UnregisterDeviceWarning: 'If you click this button, it will unregister this device from your location until the device is registered again.',

  Details: 'Details',
  User: 'User',
  Barcode: 'Barcode',
  Pin: 'PIN',
  RetypePin: 'Confirm PIN',
  Role: 'Role',
  ChangePIN: 'Change PIN',
  ChangePassword: 'Change password',
  PasswordMatchError: 'Passwords do not match.',

  NoAvailableOperations: 'There are no available operations for this item.',
  Verify: 'Verify',
  TryVerifyAgain: 'Try Verify Again',
  Dispense: 'Supply',
  Sample: 'Sample',
  Destroy: 'Destroy',
  Reintroduce: 'Reintroduce',
  PleaseWait: 'Please wait...',
  ProductCode: 'Product Code',
  AvailableOperations: 'Available operations',

  Cancel: 'Cancel',
  AddUser: 'Add User',
  EditUser: 'Edit User',

  RoleTypeOptelAdmin: 'Optel Admin',
  RoleTypeOptelSupport: 'Optel Support',
  RoleTypeTenantAdmin: 'Tenant Admin',
  RoleTypeOperator: 'Operator',
  RoleTypeViewer: 'Viewer',
  RoleTypeUnknown: 'Unknown',

  Back: 'Back',
  ActivateUser: 'Activate User',
  DeactivateUser: 'Deactivate User',
  DeleteUser: 'Delete User',
  Delete: 'Delete',
  DeleteUserWarning: 'If you click this button, this user will be deleted permanently and it\s username won\'t be available anymore.',
  DeleteUserConfirmation: 'Are you sure you want to delete {{username}} ?',
  Yes: 'Yes',
  No: 'No',
  ConfirmDeletion: 'Confirm Deletion',
  Error: 'Error',
  CommunicationError: 'An error was returned by the server.',
  SaveError: 'An error occurred while saving. Please try again later.',
  ClickTryAgain: 'Click here to try again.',
  ClickErrorIconTryAgain: 'Click the error icon to try again.',

  LandingPageSloganPart1: 'AAC - Traceability Pilot for the Canadian Primary Aluminium Industry',
  LandingPageSloganPart2: '',
  FMDAcronym: 'FMD',
  EuropeanAcronym: 'EU',
  TermsAndConditions: 'Terms & Conditions',
  AboutOptel: 'About OPTEL Group',
  AllRightsReserved: 'All rights reserved',
  OptelGroup: 'OPTEL Group',

  Online: 'Online',
  Offline: 'Offline',
  AwaitingConnection: 'Awaiting connection...',
  SimulateOffline: 'Simulate Offline',
  UndoOfflineWarning: 'Warning: Undo operation is disabled in offline mode.',

  NothingToShow: 'Nothing to show.',
  LoadingCerta: 'Certa is loading. If this takes longer than 10 seconds, please refresh the page.',

  OptelTermsOfUseTitle: 'Optel Terms of Use',
  NmvsTermsOfUseTitle: 'NMVS Terms of Use',
  NmvsTermsOfUseWarning: 'Please Note: To be accepted by the location admin',
  Accept: 'Accept',
  Decline: 'Decline',
  Ignore: 'Ignore',
  Dismiss: 'Dismiss',
  ClickHere: 'click here',

  MustAcceptTermsToLogin: 'You must accept the terms of use to log in.',
  MustBeOnlineToAcceptTermsToLogin: 'You must have internet connectivity to accept the terms of use.',

  Austria: 'Austria',
  Belgium: 'Belgium',
  Bulgaria: 'Bulgaria',
  Croatia: 'Croatia',
  Cyprus: 'Cyprus',
  CzechRepublic: 'Czech Republic',
  Denmark: 'Denmark',
  Estonia: 'Estonia',
  Finland: 'Finland',
  France: 'France',
  Germany: 'Germany',
  Greece: 'Greece',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  Ireland: 'Ireland',
  Italy: 'Italy',
  Latvia: 'Latvia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lithuania',
  Luxembourg: 'Luxembourg',
  Malta: 'Malta',
  Netherlands: 'Netherlands',
  Norway: 'Norway',
  Poland: 'Poland',
  Portugal: 'Portugal',
  Romania: 'Romania',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  Spain: 'Spain',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  UnitedKingdom: 'United Kingdom',

  UnableToParseEpc: 'Unable to parse electronic product code.',
  UnderSizeError: 'Under Size Error',
  OverSizeError: 'Over Size Error',
  FixedSizeError: 'Fixed Size Error',
  NoSerializationData: 'No serialization data.',
  InvalidCheckDigit: 'Invalid check digit.',
  NoProductCodeForGtin: 'No product code was found for GTIN.',
  UrnFormatNotSupported: 'Urn format not supported.',
  InvalidSymbologyIdentifier: 'Invalid Symbology Identifier.',
  NoSymbologyIdentifier: 'No Symbology identifier.',
  CouldNotFindTypeInfo: 'Could not find a TypeInfo.',
  NullTypeInfo: 'TypeInfo cannot be null.',
  DigitsOnly: 'Digit only AI contains non-digit characters',
  CannotSerializeUnknownAi: 'Cannot serialize AI with unknown type.',
  CheckValueNotChar: 'Character must be a digit.',
  CheckValueTooBig: 'CheckValue cannot be greater than 9.',
  InvalidFormat: 'Invalid format.',
  CapsLockDetected: 'Scan has been blocked because the CAPSLOCK key is ON.',
  CapsLockSolution: 'Press the CAPSLOCK key on your keyboard then scan the code again.',
  ScanAttemptDetected: 'A scan has been detected but could not be parsed.',
  ScanAttemptSolution: 'Please make sure your scanner is correctly configured as required by Optel to work with the Certa Application.',
  Active: 'Active',
  FullName: 'Full Name',
  OnlineAssistance: 'Certa Online Assistance',
  UnknownErrorOccurred: 'An unknown error occurred in {{function}}.',
  SeparatorMissing: 'Missing GS separator character',
  SeparatorSolution: 'Reconfigure your scanner and convert the GS character to a space or ^.',
  ScanCount: 'Scan Count',
  ProductName: 'Product Name',
  ConfirmUnregisterDeviceMessage: 'Are you sure that you want to unregister your device?',
  Confirm: 'Confirm'
};



// WEBPACK FOOTER //
// ./src/translations/translations.en.ts